module.exports = __webpack_public_path__ + "static/img/main6_2.eeaf206a.png";